import { ActivityDate } from "@/app/activity/activity-time"
import { WalletAddressLink } from "@/app/components/wallet-address"
import { PriceWrapper } from "@/app/price"
import { toUnionAddress } from "@anaconda/core/blockchain/address"
import type { DropActivity } from "@anaconda/core/drop/types"
import { Trans } from "@lingui/react/macro"
import { Skeleton } from "@rarible_int/anaconda_ui_components"
import { Cell, HeaderCell } from "./cells"

interface Column {
  Header: React.ComponentType
  Content: React.ComponentType<DropActivity>
  Skeleton: React.ComponentType
}

export const COLUMNS: Column[] = [
  {
    Header: () => (
      <HeaderCell className="w-[130px]">
        <Trans>Minter</Trans>
      </HeaderCell>
    ),
    Content: (activity) => (
      <Cell data-testid="minter">
        <WalletAddressLink
          address={toUnionAddress(activity.minter)}
          prefetch={false}
          withAvatar
        />
      </Cell>
    ),
    Skeleton: () => (
      <div className="flex items-center justify-end">
        <Skeleton className="h-6 w-[90px]" />
      </div>
    ),
  },
  {
    Header: () => (
      <HeaderCell className="w-[130px] text-right">
        <Trans>Price</Trans>
      </HeaderCell>
    ),
    Content: (activity) => (
      <Cell data-testid="price" className="text-right">
        <PriceWrapper displayZeroAsFree {...activity.price} />
      </Cell>
    ),
    Skeleton: () => (
      <div className="flex items-center justify-end">
        <Skeleton className="h-6 w-[90px]" />
      </div>
    ),
  },
  {
    Header: () => (
      <HeaderCell className="w-[100px] text-right">
        <Trans>Time</Trans>
      </HeaderCell>
    ),
    Content: (activity) => (
      <Cell data-testid="time" className="text-right">
        <ActivityDate date={new Date(activity.time)} />
      </Cell>
    ),
    Skeleton: () => <Skeleton className="h-6 w-8" />,
  },
]
